import api from "./api";

const lectureSwapService = {
  // Swap request endpoints
  createSwapRequest: (data) => api.post("/lecture-swap/requests", data),

  acceptSwapRequest: (id, data) =>
    api.post(`/lecture-swap/requests/${id}/accept`, data),

  rejectSwapRequest: (id) => api.post(`/lecture-swap/requests/${id}/reject`),

  cancelSwapRequest: (id) => api.post(`/lecture-swap/requests/${id}/cancel`),

  forceSwap: (data) => api.post("/lecture-swap/force", data),

  getSwapTargets: (slotId, params) =>
    api.get(`/lecture-swap/targets/${slotId}`, { params }),

  listSwapRequests: (params) => api.get("/lecture-swap/requests", { params }),

  getSwapRequestDetail: (id) => api.get(`/lecture-swap/requests/${id}`),

  // Extend request endpoints
  createExtendRequest: (data) => api.post("/lecture-swap/extend/requests", data),

  acceptExtendRequest: (id) =>
    api.post(`/lecture-swap/extend/requests/${id}/accept`),

  rejectExtendRequest: (id) =>
    api.post(`/lecture-swap/extend/requests/${id}/reject`),

  cancelExtendRequest: (id) =>
    api.post(`/lecture-swap/extend/requests/${id}/cancel`),

  forceExtend: (data) => api.post("/lecture-swap/extend/force", data),

  listExtendRequests: (params) =>
    api.get("/lecture-swap/extend/requests", { params }),

  getExtendRequestDetail: (id) =>
    api.get(`/lecture-swap/extend/requests/${id}`),

  // Override resolution
  getOverrides: (slotIds, date) =>
    api.get("/lecture-swap/overrides", { params: { slotIds, date } }),
};

export default lectureSwapService;
